module.exports = __webpack_public_path__ + "static/img/service.f884177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/service.png
// module id = a9OW
// module chunks = 0